(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sale-price-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sale-price-countdown')) {
    customElements.define(
      'sale-price-countdown',
      class SalePriceCountdown extends HTMLElement {
        connectedCallback() {
          this.digitsElement = this.querySelector('[data-sale-countdown-digits]');

          if (!this.digitsElement) return;

          this.disconnectedCallback();

          try {
            this.partsFormatter = new Intl.DateTimeFormat('en-US-u-ca-gregory-nu-latn', {
              timeZone: 'America/New_York',
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit',
              hourCycle: 'h23',
            });

            this.updateCountdown();
            this.hidden = false;
            this.intervalId = window.setInterval(() => this.updateCountdown(), 1000);
          } catch (error) {
            this.hidden = true;
          }
        }

        disconnectedCallback() {
          if (!this.intervalId) return;

          window.clearInterval(this.intervalId);
          this.intervalId = null;
        }

        getTimeZoneParts(date) {
          const values = {};

          for (const part of this.partsFormatter.formatToParts(date)) {
            if (part.type !== 'literal') values[part.type] = Number(part.value);
          }

          return values;
        }

        getTimeZoneOffset(date) {
          const parts = this.getTimeZoneParts(date);
          const representedAsUtc = Date.UTC(
            parts.year,
            parts.month - 1,
            parts.day,
            parts.hour,
            parts.minute,
            parts.second,
          );

          return representedAsUtc - date.getTime();
        }

        getZonedInstant(year, month, day) {
          const desiredAsUtc = Date.UTC(year, month - 1, day, 0, 0, 0);
          let candidate = desiredAsUtc;

          for (let attempt = 0; attempt < 3; attempt += 1) {
            const adjusted = desiredAsUtc - this.getTimeZoneOffset(new Date(candidate));

            if (adjusted === candidate) break;
            candidate = adjusted;
          }

          return candidate;
        }

        getNextMidnight(now) {
          const easternNow = this.getTimeZoneParts(now);
          const nextDate = new Date(Date.UTC(easternNow.year, easternNow.month - 1, easternNow.day + 1));

          return this.getZonedInstant(
            nextDate.getUTCFullYear(),
            nextDate.getUTCMonth() + 1,
            nextDate.getUTCDate(),
          );
        }

        updateCountdown() {
          const now = new Date();
          const nextMidnight = this.getNextMidnight(now);
          const totalSeconds = Math.max(0, Math.ceil((nextMidnight - now.getTime()) / 1000));
          const hours = Math.floor(totalSeconds / 3600);
          const minutes = Math.floor((totalSeconds % 3600) / 60);
          const seconds = totalSeconds % 60;

          this.digitsElement.textContent = [hours, minutes, seconds]
            .map((value) => String(value).padStart(2, '0'))
            .join(':');
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

})();
